export default __webpack_public_path__ + "static/media/us-nm.4fc1cb38.svg";